// extracted by mini-css-extract-plugin
module.exports = {"admin":"Admin-___admin__admin___3LsDu","container":"Admin-___admin__container___2DHQ3","sidebar":"Admin-___admin__sidebar___OTRTn","content":"Admin-___admin__content___cO9Dh","stickybar":"Admin-___admin__stickybar___2LjxX","space-fix":"Admin-___admin__space-fix___KaYVR","table":"Admin-___admin__table___2erl7","table-col":"Admin-___admin__table-col___f55Ji","refresh":"Admin-___admin__refresh___3NxtN"};
    if(module.hot) {
      // 1752586148001
      var cssReload = require("/builds/SilverAgent/SilverAgent/ui-parent-r2/silveragent-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"build/","hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  